import { render } from "./WantLists.vue?vue&type=template&id=78521551"
import script from "./WantLists.vue?vue&type=script&lang=js"
export * from "./WantLists.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/WantLists/WantLists.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78521551"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78521551', __exports__)) {
    api.reload('78521551', __exports__)
  }
  
  module.hot.accept("./WantLists.vue?vue&type=template&id=78521551", () => {
    api.rerender('78521551', render)
  })

}


export default __exports__